import React from 'react';
import {
  isPeriodMarketplaceLoan,
  getLoanAcceptPrice,
  getLoanCardTitle,
  getLoanPeriodHours,
  getLoanPeriodsRemaining
} from '../../../utils/loanDisplayUtils';

const AdminLoanCard = ({ loan }) => {
  const isPeriod = isPeriodMarketplaceLoan(loan);
  const periodHours = getLoanPeriodHours(loan);
  const pricePerPeriod = parseFloat(loan.price_per_period) || parseFloat(loan.total_price) || 0;
  const pricePerGW = parseFloat(loan.price_per_gw) || 0;
  const acceptPrice = getLoanAcceptPrice(loan);
  const isCompany = loan.lender_id === null || loan.lender_id === undefined;

  return (
    <div className={`bg-gray-800 rounded-lg p-6 border transition-all ${
      isCompany ? 'border-yellow-500/50 hover:border-yellow-500' : 'border-gray-700 hover:border-blue-500'
    }`}>
      <div className="flex items-center justify-between mb-4">
        <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
          isCompany 
            ? 'bg-yellow-600/30 text-yellow-300 border border-yellow-500/50'
            : 'bg-blue-600/30 text-blue-300 border border-blue-500/50'
        }`}>
          {isCompany ? '🏢 Company' : '👤 User'} {isPeriod ? 'Period Loan' : 'Loan'}
        </span>
      </div>
      
      <h3 className="text-xl font-bold text-white mb-3">
        {getLoanCardTitle(loan)}
      </h3>
      
      <div className="space-y-2 mb-4">
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-400">Position:</span>
          <span className="text-white font-semibold">{loan.player?.position || 'N/A'}</span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-400">Rarity:</span>
          <span className="text-white font-semibold">
            ⭐ {loan.rarity?.display_name || loan.rarity?.name || 'N/A'}
          </span>
        </div>
        <div className="border-t border-gray-700 pt-2 mt-2 space-y-2">
          {isPeriod ? (
            <>
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-400">Price per period ({periodHours}h):</span>
                <span className="text-yellow-400 font-semibold">{pricePerPeriod.toFixed(2)} DIOS</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-400">Periods offered:</span>
                <span className="text-white font-semibold">{loan.period_count ?? '—'}</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-400">Periods remaining:</span>
                <span className="text-white font-semibold">{getLoanPeriodsRemaining(loan)}</span>
              </div>
              <div className="flex items-center justify-between pt-2 border-t border-gray-700">
                <span className="text-gray-400 text-sm">Cost per period:</span>
                <span className="text-yellow-400 font-bold text-lg">{acceptPrice.toFixed(2)} DIOS</span>
              </div>
            </>
          ) : (
            <>
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-400">Price per Gameweek:</span>
                <span className="text-yellow-400 font-semibold">{pricePerGW.toFixed(2)} DIOS</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-400">Duration:</span>
                <span className="text-white font-semibold">{loan.duration_gw} Gameweeks</span>
              </div>
              <div className="flex items-center justify-between pt-2 border-t border-gray-700">
                <span className="text-gray-400 text-sm">Total Cost:</span>
                <span className="text-yellow-400 font-bold text-lg">{acceptPrice.toFixed(2)} DIOS</span>
              </div>
            </>
          )}
          {!isCompany && loan.lender && (
            <div className="flex items-center justify-between mt-1">
              <span className="text-gray-400 text-xs">Lender:</span>
              <span className="text-blue-400 font-semibold text-xs">
                {loan.lender.username || `User #${loan.lender_id}`}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminLoanCard;
